export enum PushType {
  SmartSetup = "smart_setup",
  SmartSetupProcessing = "smart_setup_processing",
  DocumentUploadStatus = "document_upload_status",
  DocumentArchiveStatus = "document_archive_status",
  NotificationCount = "notification_count",
  EntityMutation = "entity_mutation",
  ProductAccessChanged = "product_access_changed",
}
